module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"loading":"Carregando...","error":"Ops, tivemos algum erro por aqui! Por favor atualize a página =)"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Status.vue
// module id = 112
// module chunks = 0